const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

function handleDragEnd(result, list) {
  if (!result.destination) {
    return list;
  }

  const items = reorder(
    list,
    result.source.index,
    result.destination.index
  );
  const resultList = items.map((item, index) => {
    return {
      ...item,
      SortOrder: index + 1,
    };
  })
  return resultList;
}

const visibilityUtils = {
  handleDragEnd
}

export default visibilityUtils;
